import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MessageIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.62 9.7c0 1.1-.25 2.18-.75 3.17a7.082 7.082 0 0 1-6.33 3.92c-1.1 0-2.18-.25-3.17-.75l-4.75 1.58 1.58-4.75c-.5-.98-.75-2.07-.75-3.17 0-2.68 1.52-5.13 3.92-6.33.98-.5 2.07-.75 3.17-.75h.42c3.6.2 6.47 3.07 6.67 6.67v.42l-.01-.01Z"
      />
    </Icon>
  );
}
